module.exports = __webpack_public_path__ + "static/media/IMG_20180615_154102.811160ad.jpg";